/**
 * Section B3 Service
 * B.3.專案邊界 API 服務
 */

import axios from '../api/axios';

const BASE_URL = '/api/section-b3';

// ========== Types ==========

export interface GhgItem {
  gas_id: number;
  is_included: boolean;
  justification: string;
}

export interface EmissionSource {
  source: string;
  ghg: GhgItem[];
}

export interface SectionB3Detail {
  id: number;
  organization_id: number;
  project_id: number;
  propose: string | null;
  baseline_emissions: EmissionSource[] | null;
  project_emissions: EmissionSource[] | null;
  b_3: number;
  edit_by: number | null;
  created_at: string;
  updated_at: string | null;
}

export interface SectionB3Update {
  propose?: string;
  baseline_emissions?: EmissionSource[];
  project_emissions?: EmissionSource[];
}

// ========== API ==========

export const getSectionB3ByProject = async (projectId: number): Promise<SectionB3Detail | null> => {
  const response = await axios.get<SectionB3Detail>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

export const updateSectionB3 = async (projectId: number, data: SectionB3Update): Promise<SectionB3Detail> => {
  const response = await axios.put<SectionB3Detail>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

export const deleteSectionB3 = async (projectId: number): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}`);
};

const sectionB3Service = {
  getSectionB3ByProject,
  updateSectionB3,
  deleteSectionB3
};

export default sectionB3Service;
